// What a step page says when its save fails. The step pages only watched for success, so
// a failed save left the button on "Uploading…" with no message and no way to retry
// short of leaving the page (N24). Server messages are written for the installer (N5).
export default function stepSaveMessage(error) {
  if (error?.status === "FETCH_ERROR" || error?.status === "TIMEOUT_ERROR") {
    return "Couldn't save this step. Check your signal and try again; what you've captured is kept.";
  }
  return (
    error?.data?.error
    || error?.data?.error_message
    || error?.data?.message
    || "Couldn't save this step. Try again; what you've captured is kept."
  );
}
